import { chatReadStorageKey } from './constants';
import { getConversationId } from './conversationId';

export function loadReadCursors(uid) {
  if (!uid) return {};
  try {
    const raw = window.localStorage.getItem(chatReadStorageKey(uid));
    return raw ? JSON.parse(raw) : {};
  } catch (_) {
    return {};
  }
}

export function persistReadCursors(uid, cursors) {
  if (!uid) return;
  try {
    window.localStorage.setItem(chatReadStorageKey(uid), JSON.stringify(cursors));
  } catch (_) {}
}

export function clearReadCursorForFriend(cursors, myUid, friendId) {
  if (!myUid || !friendId) return cursors;
  const convId = getConversationId(myUid, friendId);
  if (!convId || !cursors[convId]) return cursors;
  const next = { ...cursors };
  delete next[convId];
  return next;
}
